import React from "react";
import { salesInvoiceConfig } from "../config/SalesInvoiceTableConfig";
import GenericInvoiceTable from "../tables/GenericInvoiceTable";

const SalesInvoiceTable = ({
  items,
  onItemsChange,
  setShowSidebar,
  setItemInfo,
  setCurrentLocation,
  extraFields = [],
  invoiceData,
  initialRowUnitOptions,
  setFocusedProductCode,
  currentLocation,
  currentStockInhand,
  mode,
  documentType,
  itemPricing,
}) => {
  return (
    <GenericInvoiceTable
      items={items}
      onItemsChange={onItemsChange}
      setShowSidebar={setShowSidebar}
      setItemInfo={setItemInfo}
      setCurrentLocation={setCurrentLocation}
      currentLocation={currentLocation}
      extraFields={extraFields}
      documentData={invoiceData}
      config={salesInvoiceConfig}
      initialRowUnitOptions={initialRowUnitOptions}
      setFocusedProductCode={setFocusedProductCode}
      currentStockInhand={currentStockInhand}
      mode={mode}
      documentType={documentType}
      itemPricing={itemPricing}
    />
  );
};

export default SalesInvoiceTable;
